var $3534c94e827784b7$exports = {};
$3534c94e827784b7$exports = {
    "rangeOverflow": (args)=>`O valor tem de ser ${args.maxValue} ou anterior.`,
    "rangeReversed": `A data de in\xedcio deve ser anterior \xe0 data de fim.`,
    "rangeUnderflow": (args)=>`O valor tem de ser ${args.minValue} ou posterior.`,
    "unavailableDate": `Data selecionada indispon\xedvel.`
};


export {$3534c94e827784b7$exports as default};
//# sourceMappingURL=pt-PT.mjs.map
